

import Vue from "vue";
import AppItemOption from "../../account/PriceItemOption.vue";
export default Vue.extend({
	methods: {
		sheduleDemo(){
			this.$emit("show-demo");
		}
	},
	components: {
		AppItemOption,
	}
});

